import { register } from "../../../JavaScript/Utils";
// @ts-expect-error There are no TS definitions available for captcha-eu-sdk
import { KROT } from 'captcha-eu-sdk';

export const JobDetail = (el: HTMLElement) => {

  let submitted: boolean = false;
  const divApplyBox: HTMLElement = el.querySelector(
    `.comp-job-detail--applyBox`
  );

  const divApplyBoxOpen: HTMLElement = el.querySelector(
    `.comp-job-detail--applyBox-open`
  );

  // form, apply button (= submit button) and close button are only available if the whole form was rendered;
  // this is not the case if a finisher reported an error and cancelled, e.g. the PersonioApiFinisher
  const divApplyBoxClose: HTMLElement|null = el.querySelector(
    `.comp-job-detail--applyBox-close`
  );

  const form: HTMLFormElement|null = el.querySelector(`form`);

  const submitButton: HTMLButtonElement|null = el.querySelector(
    `button[type="submit"]`
  );

  divApplyBoxOpen.addEventListener("click", function (event) {
    event.preventDefault();
    divApplyBox.classList.add("is--active");
  });

  if (divApplyBoxClose) {
    divApplyBoxClose.addEventListener("click", function (event) {
      event.preventDefault();
      divApplyBox.classList.remove("is--active");
    });
  }

  if (submitButton) {
    submitButton.addEventListener("click", async (event) => {
      if (form !== null && form.reportValidity() && form.checkValidity()) {
        if (submitted) {
          event.preventDefault();
        } else {
        const formName = form.id;
        const cptField: HTMLInputElement = form.querySelector(`#${formName}-captchaeu-1`);

        if (cptField) {
          const cptPubKey = cptField.dataset.publickey;
          const cptHost = cptField.dataset.host;

          event.preventDefault()
          KROT.setup(cptPubKey);
          KROT.KROT_HOST = cptHost;

          submitButton.innerHTML = "<div class='spinner'></div>";
          submitButton.style.cursor = "wait";
          await KROT.getSolution().then((sol: any) => {
            // write solution to hidden field
            cptField.value = JSON.stringify(sol);
            form.requestSubmit(submitButton);
            submitted = true;
          })
        } else {
          form.submit();
          submitted = true;
          submitButton.innerHTML = "<div class='spinner'></div>";
          submitButton.style.cursor = "wait";
        }
        }
      }
    });
  }

  if (window.location.hash === "#applicationform") {
    divApplyBox.classList.add("is--active");
  }
};

register("JobDetail", JobDetail);
